import { render, staticRenderFns } from "./SignUpBankAccount-2.vue?vue&type=template&id=c156f372&scoped=true"
import script from "./SignUpBankAccount-2.vue?vue&type=script&lang=js"
export * from "./SignUpBankAccount-2.vue?vue&type=script&lang=js"
import style0 from "./SignUpBankAccount-2.vue?vue&type=style&index=0&id=c156f372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c156f372",
  null
  
)

export default component.exports